export const ANALYTICS_BASE_PATH = `/TrafficDirector/`
export const ANALYTICS_BASE_PATH_HP123 = `${ANALYTICS_BASE_PATH}Hp123/`

export const ANALYTICS_TABS_PATH = [
  `${ANALYTICS_BASE_PATH}Setup/`,
  `${ANALYTICS_BASE_PATH}Learn/`,
  `${ANALYTICS_BASE_PATH}GetHelp/`
]
